import { NgModule } from "@angular/core";
import { AngularFireModule } from "@angular/fire/compat";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { NzAlertModule } from "ng-zorro-antd/alert";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzCardModule } from "ng-zorro-antd/card";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";
import { NzDatePickerModule } from "ng-zorro-antd/date-picker";
import { NzDescriptionsModule } from "ng-zorro-antd/descriptions";
import { NzDividerModule } from "ng-zorro-antd/divider";
import { NzDrawerModule } from "ng-zorro-antd/drawer";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzLayoutModule } from "ng-zorro-antd/layout";
import { NzListModule } from "ng-zorro-antd/list";
import { NzMenuModule } from "ng-zorro-antd/menu";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzPopconfirmModule } from "ng-zorro-antd/popconfirm";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzSwitchModule } from "ng-zorro-antd/switch";
import { NzTableModule } from "ng-zorro-antd/table";
import { NzTreeModule } from "ng-zorro-antd/tree";
import { environment } from "src/environments/environment";
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import { NzRadioModule } from "ng-zorro-antd/radio";

@NgModule({
   imports: [
      FormsModule, ReactiveFormsModule,
      FontAwesomeModule,
      AngularFireModule.initializeApp(environment.firebaseConfig),
      NzLayoutModule, NzMenuModule, NzDrawerModule, NzDatePickerModule, NzInputModule,
      NzSpinModule, NzAlertModule, NzIconModule, NzCardModule,
      NzSwitchModule, NzDescriptionsModule, NzDividerModule, NzListModule, NzTableModule,
      NzTreeModule, NzGridModule, NzSelectModule, NzModalModule, NzFormModule, NzButtonModule,
      NzPopconfirmModule, NzCheckboxModule, NzNotificationModule, NzToolTipModule, NzTimelineModule,
      NzRadioModule
   ],
   exports: [
      FormsModule, ReactiveFormsModule, FontAwesomeModule,

      NzLayoutModule, NzMenuModule, NzDrawerModule, NzDatePickerModule, NzInputModule,
      NzSpinModule, NzAlertModule, NzIconModule, NzCardModule,
      NzSwitchModule, NzDescriptionsModule, NzDividerModule, NzListModule, NzTableModule,
      NzTreeModule, NzGridModule, NzSelectModule, NzModalModule, NzFormModule, NzButtonModule,
      NzPopconfirmModule, NzCheckboxModule, NzNotificationModule, NzToolTipModule, NzTimelineModule,
      NzRadioModule

   ]
})
export class SharedModule { }